<template>
  <el-dialog class="store-dialog" title="选择用户" :visible.sync="showDialog" :close-on-click-modal="false" :before-close="cancelAction">
    <div style="margin-bottom: 15px;">
      <el-input placeholder="输入用户手机" v-model="mobile" clearable><el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button></el-input>
    </div>
    <el-table ref="multipleTable" :data="storeData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading" :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
      <el-table-column prop="mobile" label="手机"></el-table-column>
      <el-table-column prop="user_id" label="用户id" ></el-table-column>
      <el-table-column prop="username" label="用户名" ></el-table-column>
      <el-table-column prop="offline_card_id" label="线下会员id" ></el-table-column>
      <el-table-column prop="offline_card_code" label="线下会员卡" ></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="tr">
          <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="total_count" :page-size="pageLimit">
          </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAction">取 消</el-button>
      <el-button type="primary" @click="saveUserAction" :loading="loadingCheck">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { getMembers } from '../../api/member'
  export default {
    props: {
        isValid: {
            type: Boolean,
            default: false
        },
        userVisible: {
            type: Boolean,
            default: false
        },
        loadingCheck:{
            type: Boolean,
            default: false
        }
    },
    data () {
      return {
        loading: false,
        loadingCheck: false,
        selectRows: [],
        storeData:[],
        multipleSelection: [],
        pageLimit: 10,
        total_count: '',
        params: {
          page: 1,
          pageSize: 10,
        },
        mobile: '',
      }
    },
    methods: {
      getRowKeys (row) {
        return row.user_id
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getNewsList()
      },
      handleIconClick () {
        this.params.mobile = this.mobile
        this.getNewsList()
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      handleSelectionChange (val) {
          // console.log(val,'val')
          this.selectRows = val[0]
          // console.log(this.selectRows,'ssss')
      },
      cancelAction () {
        this.$emit('closeUserDialog')
      },
      saveUserAction () {
        this.$emit('chooseUser', this.selectRows)
      },
      getNewsList () {
          this.loading = true
          getMembers (this.params).then(response => {
            this.storeData = response.data.data.list
            this.total_count = parseInt(response.data.data.total_count)
            this.loading = false
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection()
            if (this.selectRows) {
              this.selectRows.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item)
              })
            }
         })

      }
    },
    computed: {
      showDialog () {
        return this.userVisible
      }
    },
    watch: {

      // getStatus (newVal, oldVal) {
      //   if (newVal) {
      //     this.params.is_valid = this.isValid ? this.isValid : 'true'
      //     this.getNewsList()
      //   }
      // },
    }
  }
</script>

<style type="text/css">
  .store-dialog .el-checkbox {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// index.vue?bed30134